import { AutocompleteOption } from '@types'

export const getLocalStorageContext = () => {
  const contextLs = localStorage.getItem('context')
  const context = contextLs ? (JSON.parse(contextLs) as AutocompleteOption) : null

  return context
}
